import { lazy, Suspense, type ComponentType } from 'react'
import { Spinner } from '@/components/ui'

type PageLoader<P> = () => Promise<{ default: ComponentType<P> }>

/**
 * Code-splits a route page: the module loads on first visit and the shared spinner shows meanwhile.
 * Call it once per route at module level so the lazy component is created a single time.
 */
export function lazyPage<P extends object = Record<never, never>>(load: PageLoader<P>, props?: P) {
  const Page = lazy(load)
  return (
    <Suspense fallback={<Spinner label="Loading…" />}>
      <Page {...(props ?? ({} as P))} />
    </Suspense>
  )
}
